<div class="bg-th-yellow mt-0 container-fluid">
  <div class=" d-flex justify-content-between align-content-center h-35">
    <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>
    <span class="my-auto f16 fw-bold me-2">خودرو و خدمات</span>
  </div>
</div>
<ul class="nav nav-tabs text-center dirI m-4 mx-3 position-sticky top-0 bg-white">
  <li class="nav-item">
    <a class="nav-link active " id="vehicleName" aria-current="page" (click)="setActiveTab(0, $event.target)">نام
      خودرو</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="vehicleType" (click)="setActiveTab(1, $event.target)">نوع خودرو</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="vehicleGroup" (click)="setActiveTab(3, $event.target)">گروه خودرو</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="tripReason" (click)="setActiveTab(2, $event.target)">دلیل سفر</a>
  </li>

  <li class="nav-item">
    <a class="nav-link" id="emtype" (click)="setActiveTab(4, $event.target)">نوع درخواست امداد</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="emReason" (click)="setActiveTab(5, $event.target)">علت درخواست امداد</a>
  </li>
</ul>


<!-- this is for vehicle names tab -->
<ng-container *ngIf="tabView == 0">
  <div class="container dirI">
    <div class="d-flex justify-content-between me-4">
      <div class="col-md-3 col-5">
        <div class="input-group mb-1">
          <input type="text" class="form-control rounded" placeholder="جستجو..."
            (keyup)="searchbox(0, $event.target.value)">
          <button class="btn btn-primary rounded" type="submit">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div><button class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#addNewVehicle">افزودن
          &nbsp;<i class="fa fa-plus-circle"></i></button></div>
    </div>

    <div class="table-responsive " style="max-height: 81vh;">
      <table class="table table-striped" *ngIf="vehicleNames?.length > 0">
        <thead class="position-sticky top-0 bg-white">
          <tr>
            <th>#</th>
            <th scope="col" class="position-sticky d-none">نوع خودرو</th>
            <th scope="col" class="position-sticky">تیپ خودرو</th>
            <th scope="col" class="position-sticky">نام خودرو</th>
            <th scope="col" class="position-sticky">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr [id]="'row'+item.tiGPSType" class="pointer" *ngFor="let item of vehicleNames;let i=index">
            <th class="text-dark f14">{{i+1 | faNum}}</th>
            <th class="text-dark f14"><input [disabled]="!editMode" class="input-control" type="text"
                [value]="item.strGPSTypeStyle_strComment"></th>
            <th class="text-dark f14"><input [disabled]="!editMode" class="input-control" type="text"
                [value]="item.strComment"></th>
            <th class="d-flex flex-wrap gap-2 f18">
              <i class="btn btn-outline-success fa fa-edit" (click)="editItem(0, item)"></i>
              <i class="btn btn-outline-danger fa fa-trash" (click)="deleteItem(0, item)"></i>
            </th>
          </tr>
        </tbody>
      </table>
      <div *ngIf="vehicleNames?.length == 0" class="d-flex justify-content-center align-items-center">
        <strong>موردی یافت نشد...</strong>
      </div>
    </div>
  </div>
</ng-container>

<!-- this is for vehicle types tab -->
<ng-container *ngIf="tabView == 1">
  <div class="container dirI">
    <div class="d-flex justify-content-between me-4">
      <div class="col-md-3 col-5">
        <div class="input-group mb-1">
          <input type="text" class="form-control rounded" placeholder="جستجو..."
            (keyup)="searchbox(1, $event.target.value)">
          <button class="btn btn-primary rounded" type="submit">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div><button class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#addNewType">افزودن
          &nbsp;<i class="fa fa-plus-circle"></i></button></div>
    </div>

    <div class="table-responsive " style="max-height: 81vh;">
      <table class="table table-striped" *ngIf="vehicleTypes?.length > 0">
        <thead class="position-sticky top-0 bg-white">
          <tr>
            <th>#</th>
            <th scope="col" class="position-sticky">نوع خودرو</th>
            <th scope="col" class="position-sticky">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr [id]="'row'+item.tiMobileType" class="pointer" *ngFor="let item of vehicleTypes;let i=index">
            <th class="text-dark f14">{{i+1 | faNum}}</th>
            <th class="text-dark f14"><input [disabled]="!editMode" class="input-control" type="text"
                [value]="item.strComment"></th>
            <th class="d-flex flex-wrap gap-2 f18">
              <i class="btn btn-outline-success fa fa-edit" (click)="editItem(1, item)"></i>
              <i class="btn btn-outline-danger fa fa-trash" (click)="deleteItem(1, item)"></i>
            </th>
          </tr>
        </tbody>
      </table>
      <div *ngIf="vehicleTypes?.length == 0" class="d-flex justify-content-center align-items-center">
        <strong>موردی یافت نشد...</strong>
      </div>
    </div>
  </div>
</ng-container>

<!-- this is for Trip tab -->
<ng-container *ngIf="tabView == 2">
  <div class="container dirI">
    <div class="d-flex justify-content-between me-4">
      <div class="col-md-3 col-5">
        <div class="input-group mb-1">
          <input type="text" class="form-control rounded" placeholder="جستجو..."
            (keyup)="searchbox(2, $event.target.value)">
          <button class="btn btn-primary rounded" type="submit">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div><button class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#addNewTripReason">افزودن
          &nbsp;<i class="fa fa-plus-circle"></i></button></div>
    </div>

    <div class="table-responsive " style="max-height: 81vh;">
      <table class="table table-striped" *ngIf="tripReasons?.length > 0">
        <thead class="position-sticky top-0 bg-white">
          <tr>
            <th>#</th>
            <th scope="col" class="position-sticky">توضیحات</th>
            <th scope="col" class="position-sticky">تعداد تایید سفر</th>
            <th scope="col" class="position-sticky">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr [id]="'row'+item.tiTripReason" class="pointer" *ngFor="let item of tripReasons;let i=index">
            <th class="text-dark f14">{{i+1 | faNum}}</th>
            <th class="text-dark f14"><input [disabled]="!editMode" class="input-control" type="text"
                [value]="item.strComment"></th>
            <th class="text-dark f14"><input [disabled]="!editMode" class="input-control text-start" type="number"
                [value]="item.tiConfirmationLevel"></th>
            <th class="d-flex flex-wrap gap-2 f18">
              <i class="btn btn-outline-success fa fa-edit" (click)="editItem(2, item)"></i>
              <i class="btn btn-outline-danger fa fa-trash" (click)="deleteItem(2, item)"></i>
            </th>
          </tr>
        </tbody>
      </table>
      <div *ngIf="tripReasons?.length == 0" class="d-flex justify-content-center align-items-center">
        <strong>موردی یافت نشد...</strong>
      </div>
    </div>
  </div>
</ng-container>


<!-- this is for vehicle groups tab -->
<ng-container *ngIf="tabView == 3">
  <div class="container dirI">
    <div class="d-flex justify-content-between me-4">
      <div class="col-md-3 col-5">
        <div class="input-group mb-1">
          <input type="text" class="form-control rounded" placeholder="جستجو..."
            (keyup)="searchbox(3, $event.target.value)">
          <button class="btn btn-primary rounded" type="submit">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div><button class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#addNewGroup">افزودن
          &nbsp;<i class="fa fa-plus-circle"></i></button></div>
    </div>

    <div class="table-responsive " style="max-height: 81vh;">
      <table class="table table-striped" *ngIf="vehicleGroup?.length > 0">
        <thead class="position-sticky top-0 bg-white">
          <tr>
            <th>#</th>
            <th scope="col" class="position-sticky">نام گروه خودرو</th>
            <th scope="col" class="position-sticky">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr [id]="'row'+item.tiMobileGroup" class="pointer" *ngFor="let item of vehicleGroup;let i=index">
            <th class="text-dark f14">{{i+1 | faNum}}</th>
            <th class="text-dark f14"><input [disabled]="!editMode" class="input-control" type="text"
                [value]="item.strComment"></th>
            <th class="d-flex flex-wrap gap-2 f18">
              <i class="btn btn-outline-success fa fa-edit" (click)="editItem(3, item)"></i>
              <i class="btn btn-outline-danger fa fa-trash" (click)="deleteItem(3, item)"></i>
            </th>
          </tr>
        </tbody>
      </table>
      <div *ngIf="vehicleGroup?.length == 0" class="d-flex justify-content-center align-items-center">
        <strong>موردی یافت نشد...</strong>
      </div>
    </div>
  </div>
</ng-container>

<!-- this is for relief types tab -->
<ng-container *ngIf="tabView == 4">
  <div class="container dirI">
    <div class="d-flex justify-content-between me-4">
      <div class="col-md-3 col-5">
        <div class="input-group mb-1">
          <input type="text" class="form-control rounded" placeholder="جستجو..."
            (keyup)="searchbox(4, $event.target.value)">
          <button class="btn btn-primary rounded" type="submit">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div><button class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#addReliefType">افزودن
          &nbsp;<i class="fa fa-plus-circle"></i></button></div>
    </div>

    <div class="table-responsive " style="max-height: 81vh;">
      <table class="table table-striped" *ngIf="requestTypes?.length > 0">
        <thead class="position-sticky top-0 bg-white">
          <tr>
            <th>#</th>
            <th scope="col" class="position-sticky">عنوان</th>
            <th scope="col" class="position-sticky">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr [id]="'row'+item.tiReliefRequestType" class="pointer" *ngFor="let item of requestTypes;let i=index">
            <th class="text-dark f14">{{i+1 | faNum}}</th>
            <th class="text-dark f14"><input [disabled]="!editMode" class="input-control" type="text"
                [value]="item.strComment"></th>
            <th class="d-flex flex-wrap gap-2 f18">
              <i class="btn btn-outline-success fa fa-edit" (click)="editItem(4, item)"></i>
              <i class="btn btn-outline-danger fa fa-trash" (click)="deleteItem(4, item)"></i>
            </th>
          </tr>
        </tbody>
      </table>
      <div *ngIf="requestTypes?.length == 0" class="d-flex justify-content-center align-items-center">
        <strong>موردی یافت نشد...</strong>
      </div>
    </div>
  </div>
</ng-container>

<!-- this is for relief reason tab -->
<ng-container *ngIf="tabView == 5">
  <div class="container dirI">
    <div class="d-flex justify-content-between me-4">
      <div class="col-md-3 col-5">
        <div class="input-group mb-1">
          <input type="text" class="form-control rounded" placeholder="جستجو..."
            (keyup)="searchbox(5, $event.target.value)">
          <button class="btn btn-primary rounded" type="submit">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <div><button class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#addReliefReason">افزودن
          &nbsp;<i class="fa fa-plus-circle"></i></button></div>
    </div>

    <div class="table-responsive " style="max-height: 81vh;">
      <table class="table table-striped" *ngIf="requestReasons?.length > 0">
        <thead class="position-sticky top-0 bg-white">
          <tr>
            <th>#</th>
            <th scope="col" class="position-sticky">عنوان</th>
            <th scope="col" class="position-sticky">عملیات</th>
          </tr>
        </thead>
        <tbody>
          <tr [id]="'row'+item.tiReason4Request" class="pointer" *ngFor="let item of requestReasons;let i=index">
            <th class="text-dark f14">{{i+1 | faNum}}</th>
            <th class="text-dark f14"><input [disabled]="!editMode" class="input-control" type="text"
                [value]="item.strComment"></th>
            <th class="d-flex flex-wrap gap-2 f18">
              <i class="btn btn-outline-success fa fa-edit" (click)="editItem(5, item)"></i>
              <i class="btn btn-outline-danger fa fa-trash" (click)="deleteItem(5, item)"></i>
            </th>
          </tr>
        </tbody>
      </table>
      <div *ngIf="requestReasons?.length == 0" class="d-flex justify-content-center align-items-center">
        <strong>موردی یافت نشد...</strong>
      </div>
    </div>
  </div>
</ng-container>

<!-- Modal new vehicle -->
<div class="modal fade rtl " id="addNewVehicle" tabindex="-1" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title" id="">افزودن خودرو جدید</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body col-12 d-flex flex-wrap justify-content-around">
        <div class="input-group">
          <input class="form-control" [(ngModel)]="model.vehicleName" placeholder="نوع خودرو">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="sabtNewVehicleName()">تایید <i
            class="fa fa-check-square-o"></i>
        </button>
        <button type="button" class="btn btn-primary " data-bs-dismiss="modal">انصراف <i
            class="fa fa-close"></i></button>
      </div>
    </div>
  </div>
</div>

<!-- Modal new group -->
<div class="modal fade rtl " id="addNewGroup" tabindex="-1" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title" id="">افزودن گروه خودرو جدید</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body col-12 d-flex flex-wrap justify-content-around">
        <div class="input-group">
          <input class="form-control" [(ngModel)]="model.vehicleGroup" placeholder="گروه خودرو">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="sabtNewVehicleGroup()">تایید <i
            class="fa fa-check-square-o"></i>
        </button>
        <button type="button" class="btn btn-primary " data-bs-dismiss="modal">انصراف <i
            class="fa fa-close"></i></button>
      </div>
    </div>
  </div>
</div>

<!-- Modal new Type -->
<div class="modal fade rtl " id="addNewType" tabindex="-1" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title" id="">افزودن نوع خودرو جدید</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body col-12 d-flex flex-wrap justify-content-around">
        <div class="input-group">
          <input class="form-control" [(ngModel)]="model.vehicleType" placeholder="نوع خودرو">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="sabtNewVehicleType()">تایید <i
            class="fa fa-check-square-o"></i>
        </button>
        <button type="button" class="btn btn-primary " data-bs-dismiss="modal">انصراف <i
            class="fa fa-close"></i></button>
      </div>
    </div>
  </div>
</div>

<!-- Modal new Trip Reason -->
<div class="modal fade rtl " id="addNewTripReason" tabindex="-1" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title" id="">افزودن دلیل سفر جدید</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body col-md-12  col-12 d-flex flex-wrap justify-content-around">
        <div class="input-group mb-2">
          <input class="form-control" [(ngModel)]="model.tripReason" placeholder="توضیحات">
        </div>
        <div class="input-group border border-dark">
          <input class="form-control text-start" type="number" min="0" [(ngModel)]="model.tripConfirmationCount"
            placeholder="تعداد تایید سفر">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="sabtNewTripReason()">تایید <i
            class="fa fa-check-square-o"></i>
        </button>
        <button type="button" class="btn btn-primary " data-bs-dismiss="modal">انصراف <i
            class="fa fa-close"></i></button>
      </div>
    </div>
  </div>
</div>

<!-- Modal new Relief Type -->
<div class="modal fade rtl " id="addReliefType" tabindex="-1" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title" id="">افزودن نوع امداد جدید</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body col-12 d-flex flex-wrap justify-content-around">
        <div class="input-group">
          <input class="form-control" [(ngModel)]="model.reliefType" placeholder="نوع امداد">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="sabtNewReliefType()">تایید <i
            class="fa fa-check-square-o"></i>
        </button>
        <button type="button" class="btn btn-primary " data-bs-dismiss="modal">انصراف <i
            class="fa fa-close"></i></button>
      </div>
    </div>
  </div>
</div>

<!-- Modal new Relief Reason -->
<div class="modal fade rtl " id="addReliefReason" tabindex="-1" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content ">
      <div class="modal-header">
        <h5 class="modal-title" id="">افزودن دلیل امداد جدید</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body col-12 d-flex flex-wrap justify-content-around">
        <div class="input-group">
          <input class="form-control" [(ngModel)]="model.reliefReason" placeholder="دلیل امداد">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="sabtNewReliefReason()">تایید <i
            class="fa fa-check-square-o"></i>
        </button>
        <button type="button" class="btn btn-primary " data-bs-dismiss="modal">انصراف <i
            class="fa fa-close"></i></button>
      </div>
    </div>
  </div>
</div>